import axios from 'axios';

export default {
  state: {
    page: {},
    loading: false,
    pageError: null,
    pageLoaded: false
  },
  mutations: {
    SET_PAGE(state, page) {
      state.page = page;
      state.pageLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_PAGE_LOADING(state, status) {
      state.pageLoading = status;
    },
    UNSET_PAGE(state) {
      state.pageLoaded = false;
      state.pageLoading = false;
      state.page = {};
    },
    SET_PAGE_ERROR(state, error) {
      state.pageError = error;
    }
  },
  actions: {
    async fetchPage({ commit, state }, id) {
      commit('UNSET_PAGE');

      try {
        commit('SET_PAGE_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/page/'+id+'/');
        if (response.data.status != 'error') {
          commit('SET_PAGE', response.data.data);
          commit('SET_PAGE_ERROR', null);
        }
        else
          commit('SET_PAGE_ERROR', response.data.errors[0]['message']);
      } catch (error) {
        commit('SET_PAGE_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching page:', error);
      } finally {
        commit('SET_PAGE_LOADING', false);
      }
    }
  },
  getters: {
    page: state => state.page,
    pageLoading: state => state.pageLoading,
    pageError: state => state.pageError,
    pageLoaded: state => state.pageLoaded
  }
}